import React from 'react';
import { BackTop } from 'antd';
import './AffixTop.scss';

const AffixTop = () => {
  return (
    <>
      <div className="right-btm">
        <div className="code">
          <div></div>
        </div>
        <div className="phone">
          <div>025-83342299</div>
        </div>
        <BackTop>
          <div className="backTop"></div>
        </BackTop>
      </div>
    </>
  );
};

export default AffixTop;
